import ScrollManager from "@web/vpt-assets/assets/js/utilities/scrollManager";

export default class ScrollToManager{

    constructor() {
        this.scrollManager = new ScrollManager()
        this.scrollToSection()
    }

    scrollToSection() {
        let tagId = this.getParameter('section')
        if (tagId != null){
            let offsetHeight = this.calculateOffsetHeight()
            this.scrollManager.scrollTo(
                '#section' + tagId,
                ()=>{},
                45,
                false,
                offsetHeight
            )
        }
    }

    calculateOffsetHeight() {
        if (myApp.deviceDetector.isXsScreen() || myApp.deviceDetector.isSmScreen()) {
            return document.getElementsByClassName('menu-navigation')[0].clientHeight
        } else {
            return 0
        }
    }

    getParameter(parameter) {
        let getParams = new URLSearchParams(window.location.search)
        let tagId = getParams.get(parameter)
        return this.isValidParameter('section' + tagId) ? tagId : null
    }

    isValidParameter(tagId) {
        return !!document.getElementById(tagId);
    }
}